import DriverInfo from "./DriverInfo";

export default DriverInfo;
